module.exports = __webpack_public_path__ + "img/calla.5e8143d1.jpg";